var _rect, _path, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _circle, _path2, _rect1, _g, _rect10, _path3, _rect11, _rect12, _rect13, _rect14, _path4, _rect15, _circle2, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeatPayment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 340 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 40,
    width: 206,
    height: 172,
    rx: 16,
    fill: "#FFFFFF",
    stroke: "#ECEEF2",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 56a16 16 0 0 1 16-16h174a16 16 0 0 1 16 16v12H26z",
    fill: "#E4F6EC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 48,
    width: 80,
    height: 8,
    rx: 4,
    fill: "#BFE8CE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 84,
    width: 70,
    height: 7,
    rx: 3.5,
    fill: "#E5E8EE"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 84,
    width: 38,
    height: 7,
    rx: 3.5,
    fill: "#EEF1F5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 104,
    width: 58,
    height: 7,
    rx: 3.5,
    fill: "#E5E8EE"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 104,
    width: 30,
    height: 7,
    rx: 3.5,
    fill: "#EEF1F5"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 126,
    width: 170,
    height: 2,
    rx: 1,
    fill: "#F1F3F7"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 138,
    width: 46,
    height: 8,
    rx: 4,
    fill: "#CDD3DD"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 135,
    width: 56,
    height: 12,
    rx: 4,
    fill: "#16A34A"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 166,
    width: 110,
    height: 28,
    rx: 14,
    fill: "#E4F6EC"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 180,
    r: 9,
    fill: "#16A34A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58 180l3 3 5-6",
    stroke: "#FFFFFF",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 177,
    width: 58,
    height: 6,
    rx: 3,
    fill: "#BFE8CE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-7 270 96)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 222,
    y: 62,
    width: 96,
    height: 60,
    rx: 11,
    fill: "#16A34A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222,
    y: 80,
    width: 96,
    height: 11,
    fill: "#0F7F39"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 102,
    width: 30,
    height: 7,
    rx: 3.5,
    fill: "#9FE0B6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 302,
    cy: 106,
    r: 9,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298 106l2.6 2.6 4.6-5.4",
    stroke: "#16A34A",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 176,
    width: 146,
    height: 34,
    rx: 13,
    fill: "#FFFFFF",
    stroke: "#ECEEF2",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M188 188h18l-9-7z",
    fill: "#16A34A"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 189,
    y: 189,
    width: 3.4,
    height: 9,
    fill: "#16A34A"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 195.3,
    y: 189,
    width: 3.4,
    height: 9,
    fill: "#16A34A"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 201.6,
    y: 189,
    width: 3.4,
    height: 9,
    fill: "#16A34A"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 199,
    width: 22,
    height: 3,
    rx: 1.5,
    fill: "#16A34A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M218 193h20m0 0l-5-4m5 4l-5 4",
    stroke: "#9AA3B2",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 190,
    width: 36,
    height: 6,
    rx: 3,
    fill: "#E5E8EE"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 193,
    r: 8,
    fill: "#E4F6EC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M296.5 193l2.5 2.5 4.5-5",
    stroke: "#16A34A",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatPayment);
export default __webpack_public_path__ + "static/media/feat-payment.4864ffe4ff4c23f3285c6f4526feb179.svg";
export { ForwardRef as ReactComponent };